import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormNewsletterComponent } from '@app/core/user/components/form-newsletter/form-newsletter.component';
import { FormRegisterComponent } from '@app/core/user/components/form-register/form-register.component';
import { RegisterComponent } from '@app/core/user/components/register/register.component';

import { SharedModule } from '@app/shared/shared.module';
import { FacebookConnectModule } from '@app/core/user/components/facebook-connect/facebook-connect.module';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule, FacebookConnectModule],
  declarations: [RegisterComponent, FormRegisterComponent, FormNewsletterComponent],
  exports: [RegisterComponent],
  entryComponents: [RegisterComponent]
})
export class RegisterModule {}
